<script setup lang="ts">
import { nextTick, ref, watch } from "vue";

const model = defineModel<boolean>({ default: false });

const props = withDefaults(
  defineProps<{
    isError?: boolean;
    shakeNonce?: number;
  }>(),
  {
    isError: false,
    shakeNonce: 0,
  },
);

const isShaking = ref(false);
let shakeTimer: ReturnType<typeof setTimeout> | null = null;

watch(
  () => props.shakeNonce,
  (next, prev) => {
    if (!next || next === prev) return;
    isShaking.value = false;
    nextTick(() => {
      isShaking.value = true;
      if (shakeTimer) clearTimeout(shakeTimer);
      shakeTimer = setTimeout(() => {
        isShaking.value = false;
      }, 450);
    });
  },
);
</script>

<template>
  <label
    class="flex cursor-pointer items-start gap-2 text-xs lg:text-base leading-6 text-ink"
    :class="{ 'animate-shake': isShaking }"
  >
    <input v-model="model" class="peer sr-only" type="checkbox" />
    <span
      class="relative mt-0.5 h-5 w-5 min-w-5 rounded-[4px] peer-focus-visible:ring-2 peer-focus-visible:ring-brand/40 peer-focus-visible:ring-offset-2"
      :class="isError && !model ? 'text-darkred' : 'text-brand'"
      aria-hidden="true"
    >
      <svg
        class="absolute inset-0 h-5 w-5 transition-opacity duration-150"
        :class="model ? 'opacity-0' : 'opacity-100'"
        viewBox="0 0 20 20"
      >
        <use href="#ticket-widget-icon-checkbox-off" />
      </svg>
      <svg
        class="absolute inset-0 h-5 w-5 transition-opacity duration-150"
        :class="model ? 'opacity-100' : 'opacity-0'"
        viewBox="0 0 20 20"
      >
        <use href="#ticket-widget-icon-checkbox-on" />
      </svg>
    </span>
    <span class="min-w-0 select-none">
      <slot />
    </span>
  </label>
</template>
